// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"6dcc924c","448":"26c19712","545":"eaf11090","631":"2ab1f342"}[chunkId] + ".chunk.js";
};